import { config } from '@/config.ts';

type BrandPhoneMaskConfig = Record<string, string>;

/**
 * Map of phone masks for each brand
 * Used in login/registration forms
 */
export const brandPhoneMaskMap: BrandPhoneMaskConfig = {
	default: '+{7}(000) 000 - 00 - 00',
	nomad: '+{7}(000) 000 - 00 - 00',
	ngu3: '+{38\\0}(00) 000 - 00 - 00',
	com2: '+{38\\0}(00) 000 - 00 - 00',
	blitz: '+{9\\0}(000) 000 - 0000',
	rockets: '+{38\\0}(00) 000 - 00 - 00',
	rockets_vip: '+{38\\0}(00) 000 - 00 - 00',
	sk2: '+{38\\0}(00) 000 - 00 - 00',
	'1king': '+{9\\0}(000) 000 - 0000'
};

/**
 * Get phone mask for the current brand
 * @returns string - Phone mask for current brand
 */
export const getBrandPhoneMask = (): string => {
	const brand = config.BRAND || 'default';
	return brandPhoneMaskMap[brand] || brandPhoneMaskMap.default;
};

